import React from "react"
import { FlexContainer, Image, H2, Container } from "@carrotfertility/carotene"
import { LeftArrow } from "../../views/atoms/Molecules"
import { useGetCaseRateRenewalStatus } from "./useQueryCaseRateRenewals"

type CaseRateRenewalModalTopSectionProps = {
  showBack?: boolean
  back?: () => void
  showImage?: boolean
  imageSrc?: string
  imageAltText?: string
  header?: string
  disabledBack?: boolean
}

export function CaseRateRenewalModalTopSection({
  showBack = false,
  back = null,
  showImage = false,
  imageSrc = null,
  imageAltText = null,
  header = null,
  disabledBack = false
}: CaseRateRenewalModalTopSectionProps): JSX.Element {
  const { showAdvancedCheckInFeatures } = useGetCaseRateRenewalStatus()
  return (
    <>
      {showBack ? (
        <Container
          sx={{ marginTop: showAdvancedCheckInFeatures ? [-50, -50, -80, -80] : null }}
          stack={["small", "huge"]}
        >
          <LeftArrow onClick={disabledBack ? null : back} />
        </Container>
      ) : null}
      {showImage ? (
        <FlexContainer stack={["medium", "large"]} justifyContent="center">
          <Image
            src={imageSrc}
            srcSet={`${imageSrc}-2x.png`}
            altText={`${imageAltText}.png`}
            height={"237px"}
            width={"300px"}
          />
        </FlexContainer>
      ) : null}
      <H2 stack="tiny">{header}</H2>
    </>
  )
}
